<ng-template #email [appCtrlTemplate]="'email'">
  <mail> </mail>
</ng-template>
<ng-template #childrenForm [appCtrlTemplate]="'childrenForm'">
  <children-form> </children-form>
</ng-template>
<ng-template #personnesACharges [appCtrlTemplate]="'personnesACharges'">
  <personnes-a-charges> </personnes-a-charges>
</ng-template>
<ng-template #civilState [appCtrlTemplate]="'civilState'">
  <civil-state-form> </civil-state-form>
</ng-template>

<ng-template
  #companySituationComptable
  [appCtrlTemplate]="'companySituationComptable'"
>
  <company-situation-comptable-form> </company-situation-comptable-form>
</ng-template>
<ng-template #companyProfile [appCtrlTemplate]="'companyProfile'">
  <company-profile-form> </company-profile-form>
</ng-template>
<ng-template #companyAddresses [appCtrlTemplate]="'companyAddresses'">
  <company-addresses-form> </company-addresses-form>
</ng-template>
<ng-template #paymentPrimes [appCtrlTemplate]="'paymentPrimes'">
  <payment-primes> </payment-primes>
</ng-template>
<ng-template #risquesOperations [appCtrlTemplate]="'risquesOperations'">
  <risques-operations> </risques-operations>
</ng-template>
<ng-template #risquesDistribution [appCtrlTemplate]="'risquesDistribution'">
  <risques-distribution> </risques-distribution>
</ng-template>
<ng-template
  #risquesClientPersonneMorale
  [appCtrlTemplate]="'risquesClientPersonneMorale'"
>
  <risques-client-personne-morale>
  </risques-client-personne-morale> </ng-template
><ng-template
  #risquesClientPersonnePhysique
  [appCtrlTemplate]="'risquesClientPersonnePhysique'"
>
  <risques-client-personne-physique> </risques-client-personne-physique>
</ng-template>

<ng-template
  #companyBeneficialowner
  [appCtrlTemplate]="'companyBeneficialowner'"
>
  <company-beneficialowner-form> </company-beneficialowner-form>
</ng-template>

<ng-template #birthInfo [appCtrlTemplate]="'birthInfo'">
  <birth-info-form> </birth-info-form>
</ng-template>

<ng-template #address [appCtrlTemplate]="'address'">
  <address-form> </address-form>
</ng-template>

<ng-template #taxResidency [appCtrlTemplate]="'taxResidency'">
  <tax-residency-form> </tax-residency-form>
</ng-template>

<ng-template #phone [appCtrlTemplate]="'phone'">
  <phone-form> </phone-form>
</ng-template>

<ng-template #otherInfo [appCtrlTemplate]="'otherInfo'">
  <other-info-form> </other-info-form>
</ng-template>

<ng-template #userNifCode [appCtrlTemplate]="'userNifCode'">
  <user-nif-code-form> </user-nif-code-form>
</ng-template>

<ng-template #userNifCodeExample [appCtrlTemplate]="'userNifCodeExample'">
  <user-nif-code-example> </user-nif-code-example>
</ng-template>

<ng-template #profilePage [appCtrlTemplate]="'profilePage'">
  <ea-subscription-completed-profile-page>
  </ea-subscription-completed-profile-page>
</ng-template>

<ng-template #maritalStatus [appCtrlTemplate]="'maritalStatus'">
  <marital-status-form> </marital-status-form>
</ng-template>

<ng-template #spouseInfo [appCtrlTemplate]="'spouseInfo'">
  <spouse-info-form> </spouse-info-form>
</ng-template>

<ng-template #dependentChildren [appCtrlTemplate]="'dependentChildren'">
  <dependent-children-form> </dependent-children-form>
</ng-template>

<ng-template #income [appCtrlTemplate]="'income'">
  <income-form> </income-form>
</ng-template>

<ng-template #profession [appCtrlTemplate]="'profession'">
  <profession-form> </profession-form>
</ng-template>

<ng-template #heritage [appCtrlTemplate]="'heritage'">
  <heritage-form> </heritage-form>
</ng-template>

<ng-template #wealthDistribution [appCtrlTemplate]="'wealthDistribution'">
  <wealth-distribution-form> </wealth-distribution-form>
</ng-template>

<ng-template #principalResidence [appCtrlTemplate]="'principalResidence'">
  <principal-residence-form> </principal-residence-form>
</ng-template>

<ng-template #savingsCapacity [appCtrlTemplate]="'savingsCapacity'">
  <savings-capacity-form> </savings-capacity-form>
</ng-template>

<ng-template #investmentObjective [appCtrlTemplate]="'investmentObjective'">
  <investment-objective-form> </investment-objective-form>
</ng-template>
<ng-template
  #investmentObjectiveHeritage
  [appCtrlTemplate]="'investmentObjectiveHeritage'"
>
  <investment-objective-heritage> </investment-objective-heritage>
</ng-template>

<ng-template #investmentDuration [appCtrlTemplate]="'investmentDuration'">
  <investment-period-form> </investment-period-form>
</ng-template>
<ng-template #subscribeInLife [appCtrlTemplate]="'subscribeInLife'">
  <subscribe-in-life> </subscribe-in-life>
</ng-template>

<ng-template #scpiKnowledge [appCtrlTemplate]="'scpiKnowledge'">
  <scpi-knowledge> </scpi-knowledge>
</ng-template>
<ng-template #moneyGames [appCtrlTemplate]="'moneyGames'">
  <money-games-form> </money-games-form>
</ng-template>

<ng-template #savingsRate [appCtrlTemplate]="'savingsRate'">
  <savings-rate-form> </savings-rate-form>
</ng-template>

<ng-template #existingInvestments [appCtrlTemplate]="'existingInvestments'">
  <existing-investments-form> </existing-investments-form>
</ng-template>

<ng-template #investmentKnowledge [appCtrlTemplate]="'investmentKnowledge'">
  <investment-knowledge-form> </investment-knowledge-form>
</ng-template>

<ng-template #financialKnowledge1 [appCtrlTemplate]="'financialKnowledge1'">
  <financial-knowledge1-form> </financial-knowledge1-form>
</ng-template>

<ng-template #financialKnowledge2 [appCtrlTemplate]="'financialKnowledge2'">
  <financial-knowledge2-form> </financial-knowledge2-form>
</ng-template>

<ng-template #financialKnowledge3 [appCtrlTemplate]="'financialKnowledge3'">
  <financial-knowledge3-form> </financial-knowledge3-form>
</ng-template>

<ng-template #financialKnowledge4 [appCtrlTemplate]="'financialKnowledge4'">
  <financial-knowledge4-form> </financial-knowledge4-form>
</ng-template>

<ng-template #financialKnowledge7 [appCtrlTemplate]="'financialKnowledge7'">
  <financial-knowledge7-form> </financial-knowledge7-form>
</ng-template>

<ng-template #financialKnowledge8 [appCtrlTemplate]="'financialKnowledge8'">
  <financial-knowledge8-form> </financial-knowledge8-form>
</ng-template>

<ng-template #initializationCredit [appCtrlTemplate]="'initializationCredit'">
  <initialization-credit-form> </initialization-credit-form>
</ng-template>
<ng-template
  #creditGeneralInformations
  [appCtrlTemplate]="'creditGeneralInformations'"
>
  <credit-general-informations> </credit-general-informations>
</ng-template>
<ng-template
  #creditOwnersProfessionDetails
  [appCtrlTemplate]="'creditOwnersProfessionDetails'"
>
  <credit-owners-profession-details> </credit-owners-profession-details>
</ng-template>
<ng-template #creditInformations [appCtrlTemplate]="'creditInformations'">
  <credit-informations> </credit-informations>
</ng-template>
<ng-template
  #creditInsuranceQuotite
  [appCtrlTemplate]="'creditInsuranceQuotite'"
>
  <credit-insurance-quotite> </credit-insurance-quotite>
</ng-template>
<ng-template #creditDiffere [appCtrlTemplate]="'creditDiffere'">
  <credit-differe> </credit-differe>
</ng-template>
<ng-template #creditGuarantees [appCtrlTemplate]="'creditGuarantees'">
  <credit-guarantees> </credit-guarantees>
</ng-template>
<ng-template
  #creditOptionTarification
  [appCtrlTemplate]="'creditOptionTarification'"
>
  <credit-option-tarification> </credit-option-tarification>
</ng-template>
<ng-template
  #creditManualTarification
  [appCtrlTemplate]="'creditManualTarification'"
>
  <credit-manual-tarification> </credit-manual-tarification>
</ng-template>
<ng-template #creditOutstandings [appCtrlTemplate]="'creditOutstandings'">
  <credit-outstandings> </credit-outstandings>
</ng-template>
<ng-template #creditTarification [appCtrlTemplate]="'creditTarification'">
  <credit-tarification> </credit-tarification>
</ng-template>
<ng-template
  #creditAdditionnalInformations
  [appCtrlTemplate]="'creditAdditionnalInformations'"
>
  <credit-additionnal-informations> </credit-additionnal-informations>
</ng-template>
<ng-template
  #creditDocumentationAssureur
  [appCtrlTemplate]="'creditDocumentationAssureur'"
>
  <credit-documentation-assureur> </credit-documentation-assureur>
</ng-template>

<ng-template
  #initializationContract
  [appCtrlTemplate]="'initializationContract'"
>
  <initialization-contract-form> </initialization-contract-form>
</ng-template>

<ng-template
  #pourcentageDeRemiseForm
  [appCtrlTemplate]="'pourcentageDeRemiseForm'"
>
  <pourcentage-de-remise-form> </pourcentage-de-remise-form>
</ng-template>
<ng-template #codeParrainageForm [appCtrlTemplate]="'codeParrainageForm'">
  <code-parrainage-form> </code-parrainage-form>
</ng-template>

<ng-template #scpiOwnershipType [appCtrlTemplate]="'scpiOwnershipType'">
  <ownership-type-scpi> </ownership-type-scpi>
</ng-template>
<ng-template #selectSCPI [appCtrlTemplate]="'selectSCPI'">
  <select-scpi> </select-scpi>
</ng-template>

<ng-template #productForm [appCtrlTemplate]="'productForm'">
  <switcher-scpi> </switcher-scpi>
</ng-template>
<ng-template #SCPIConfiguration [appCtrlTemplate]="'SCPIConfiguration'">
  <scpi-configuration> </scpi-configuration>
</ng-template>
<ng-template #scpiAmount [appCtrlTemplate]="'scpiAmount'">
  <scpi-amount> </scpi-amount>
</ng-template>
<ng-template #scpiTable [appCtrlTemplate]="'scpiTable'">
  <scpi-table> </scpi-table>
</ng-template>

<ng-template #riskLevelExpected [appCtrlTemplate]="'riskLevelExpected'">
  <risk-level-form> </risk-level-form>
</ng-template>

<ng-template #riskTotalLoss [appCtrlTemplate]="'riskTotalLoss'">
  <risk-total-loss> </risk-total-loss>
</ng-template>
<!-- assessment-assets-form -->
<ng-template #assessmentAssets [appCtrlTemplate]="'assessmentAssets'">
  <assessment-assets-form> </assessment-assets-form>
</ng-template>
<ng-template
  #assessmentAssetsOrigin
  [appCtrlTemplate]="'assessmentAssetsOrigin'"
>
  <assessment-assets-originform> </assessment-assets-originform>
</ng-template>

<ng-template
  #assessmentAssetsIncome
  [appCtrlTemplate]="'assessmentAssetsIncome'"
>
  <assessment-assets-incomeform> </assessment-assets-incomeform>
</ng-template>
<ng-template
  #assessmentAssetsIncomeServiceDelivery
  [appCtrlTemplate]="'assessmentAssetsIncomeServiceDelivery'"
>
  <assessment-assets-income-service-delivery>
  </assessment-assets-income-service-delivery>
</ng-template>
<ng-template #invest [appCtrlTemplate]="'invest'">
  <invest-form> </invest-form>
</ng-template>

<ng-template #fundsInitialPayment [appCtrlTemplate]="'fundsInitialPayment'">
  <funds-initial-payment-form> </funds-initial-payment-form>
</ng-template>

<ng-template #investmentAllocation [appCtrlTemplate]="'investmentAllocation'">
  <investment-allocation-form> </investment-allocation-form>
</ng-template>

<ng-template #support [appCtrlTemplate]="'support'">
  <support-form> </support-form>
</ng-template>

<ng-template #tauxParSupport [appCtrlTemplate]="'tauxParSupport'">
  <taux-par-support> </taux-par-support>
</ng-template>

<ng-template #isinTable [appCtrlTemplate]="'isinTable'">
  <isin-table> </isin-table>
</ng-template>

<ng-template #garantiePlancher [appCtrlTemplate]="'garantiePlancher'">
  <garantie-plancher> </garantie-plancher>
</ng-template>
<ng-template
  #exonerationArretTravail
  [appCtrlTemplate]="'exonerationArretTravail'"
>
  <exoneration-arret-travail> </exoneration-arret-travail>
</ng-template>
<ng-template
  #swisslifeRenonceProfil
  [appCtrlTemplate]="'swisslifeRenonceProfil'"
>
  <swisslife-renonce-profil> </swisslife-renonce-profil>
</ng-template>

<ng-template #optionConfiguration [appCtrlTemplate]="'optionConfiguration'">
  <option-configuration> </option-configuration>
</ng-template>

<ng-template
  #investmentAmountDuration
  [appCtrlTemplate]="'investmentAmountDuration'"
>
  <investment-amount-duration-form> </investment-amount-duration-form>
</ng-template>

<ng-template
  #investissementSupportForm
  [appCtrlTemplate]="'investissementSupportForm'"
>
  <investissement-support-form> </investissement-support-form>
</ng-template>

<ng-template
  #investissementProgressifTable
  [appCtrlTemplate]="'investissementProgressifTable'"
>
  <investissement-progressif-table> </investissement-progressif-table>
</ng-template>

<ng-template #securisationPlus [appCtrlTemplate]="'securisationPlus'">
  <securisation-plus-values> </securisation-plus-values>
</ng-template>

<ng-template
  #securisationMoinsValues
  [appCtrlTemplate]="'securisationMoinsValues'"
>
  <securisation-moins-values> </securisation-moins-values>
</ng-template>

<ng-template #beneficiary [appCtrlTemplate]="'beneficiary'">
  <beneficiary-clause-form> </beneficiary-clause-form>
</ng-template>

<ng-template #document [appCtrlTemplate]="'document'">
  <document-form> </document-form>
</ng-template>

<ng-template #justificatifDomicile [appCtrlTemplate]="'justificatifDomicile'">
  <justificatif-domicile-form> </justificatif-domicile-form>
</ng-template>
<ng-template
  #justificatifOrigineDesFonds
  [appCtrlTemplate]="'justificatifOrigineDesFonds'"
>
  <justificatif-origine-des-fonds-form> </justificatif-origine-des-fonds-form>
</ng-template>
<ng-template #cellphoneBillId [appCtrlTemplate]="'cellphoneBillId'">
  <phone-bill-form> </phone-bill-form>
</ng-template>
<ng-template #ribForm [appCtrlTemplate]="'ribForm'">
  <rib-form> </rib-form>
</ng-template>
<ng-template #familyBookForm [appCtrlTemplate]="'familyBookForm'">
  <family-book-form> </family-book-form>
</ng-template>
<ng-template #offreDePretForm [appCtrlTemplate]="'offreDePretForm'">
  <offre-de-pret-form> </offre-de-pret-form>
</ng-template>
<ng-template #fsiForm [appCtrlTemplate]="'fsiForm'">
  <fsi-form> </fsi-form>
</ng-template>
<ng-template #kbisForm [appCtrlTemplate]="'kbisForm'">
  <kbis-form> </kbis-form>
</ng-template>
<ng-template
  #attestationBeneficiairesEffectifsForm
  [appCtrlTemplate]="'attestationBeneficiairesEffectifsForm'"
>
  <attestation-beneficiaires-effectifs-form>
  </attestation-beneficiaires-effectifs-form>
</ng-template>
<ng-template #accountResultsForm [appCtrlTemplate]="'accountResultsForm'">
  <account-results-form> </account-results-form>
</ng-template>
<ng-template #statutsSocieteForm [appCtrlTemplate]="'statutsSocieteForm'">
  <statuts-societe-form> </statuts-societe-form>
</ng-template>
<ng-template
  #rcsRegistrationExtractForm
  [appCtrlTemplate]="'rcsRegistrationExtractForm'"
>
  <rcs-registration-extract> </rcs-registration-extract>
</ng-template>
<ng-template #bilanForm [appCtrlTemplate]="'bilanForm'">
  <bilan-form> </bilan-form>
</ng-template>
<ng-template #carteVitaleForm [appCtrlTemplate]="'carteVitaleForm'">
  <carte-vitale-form> </carte-vitale-form>
</ng-template>
<ng-template
  #justificatifSituationMatrimonialeForm
  [appCtrlTemplate]="'justificatifSituationMatrimonialeForm'"
>
  <justificatif-situation-matrimoniale-form>
  </justificatif-situation-matrimoniale-form>
</ng-template>
<ng-template #contratMariageForm [appCtrlTemplate]="'contratMariageForm'">
  <contrat-mariage-form> </contrat-mariage-form>
</ng-template>

<ng-template #lifeInsuranceFees [appCtrlTemplate]="'lifeInsuranceFees'">
  <life-insurance-fees-form> </life-insurance-fees-form>
</ng-template>
<ng-template #fees [appCtrlTemplate]="'fees'">
  <fees-form> </fees-form>
</ng-template>
<ng-template #signatureElectronic [appCtrlTemplate]="'signatureElectronic'">
  <electronic-signature-form> </electronic-signature-form>
</ng-template>
<ng-template #paymentForm [appCtrlTemplate]="'paymentForm'">
  <payment-form> </payment-form>
</ng-template>
<ng-template #paymentCristalisForm [appCtrlTemplate]="'paymentcristalisForm'">
  <payment-cristalis-form> </payment-cristalis-form>
</ng-template>
<ng-template #rentPaymentIban [appCtrlTemplate]="'rentPaymentIban'">
  <rent-payment-iban> </rent-payment-iban>
</ng-template>
<ng-template
  #fundsInitialPaymentScpi
  [appCtrlTemplate]="'fundsInitialPaymentScpi'"
>
  <funds-initial-payment-scpi-form> </funds-initial-payment-scpi-form>
</ng-template>

<ng-template #loanRepartitionForm [appCtrlTemplate]="'loanRepartitionForm'">
  <loan-repartition-form> </loan-repartition-form>
</ng-template>

<ng-template #clientAdequation [appCtrlTemplate]="'clientAdequation'">
  <client-adequation-form> </client-adequation-form>
</ng-template>
<ng-template #girardiAmount [appCtrlTemplate]="'girardiAmount'">
  <girardi-amount> </girardi-amount>
</ng-template>

<ng-template #crowdfundingAmount [appCtrlTemplate]="'crowdfundingAmount'">
  <crowdfunding-amount> </crowdfunding-amount>
</ng-template>

<ng-template #crowdfundingSettings [appCtrlTemplate]="'crowdfundingSettings'">
  <crowdfunding-settings> </crowdfunding-settings>
</ng-template>
<ng-template #crowdfundingSettings2 [appCtrlTemplate]="'crowdfundingSettings2'">
  <crowdfunding-settings2> </crowdfunding-settings2>
</ng-template>

<ng-template
  #crowdfundingProjectDuration
  [appCtrlTemplate]="'crowdfundingProjectDuration'"
>
  <crowdfunding-project-duration> </crowdfunding-project-duration>
</ng-template>

<ng-template #crowdfundingFees [appCtrlTemplate]="'crowdfundingFees'">
  <crowdfunding-fees> </crowdfunding-fees>
</ng-template>

<!--
// FCPI -->
<ng-template #fcpiAmount [appCtrlTemplate]="'fcpiAmount'">
  <fcpi-amount> </fcpi-amount>
</ng-template>

<ng-template #fcpiSettings [appCtrlTemplate]="'fcpiSettings'">
  <fcpi-setting> </fcpi-setting>
</ng-template>
<ng-template #fcpiSettings2 [appCtrlTemplate]="'fcpiSettings2'">
  <fcpi-setting2> </fcpi-setting2>
</ng-template>

<ng-template #fcpiProjectDuration [appCtrlTemplate]="'fcpiProjectDuration'">
  <fcpi-project-duration> </fcpi-project-duration>
</ng-template>

<ng-template #fcpiFees [appCtrlTemplate]="'fcpiFees'">
  <fcpi-fees> </fcpi-fees>
</ng-template>

<ng-template #bondAmount [appCtrlTemplate]="'bondAmount'">
  <bond-amount> </bond-amount>
</ng-template>
<ng-template #bondProjectDuration [appCtrlTemplate]="'bondProjectDuration'">
  <bond-project-duration> </bond-project-duration>
</ng-template>
<ng-template #bondFees [appCtrlTemplate]="'bondFees'">
  <bond-fees> </bond-fees>
</ng-template>

<ng-template
  #titresParticipatifsAmount
  [appCtrlTemplate]="'titresParticipatifsAmount'"
>
  <titres-participatifs-amount> </titres-participatifs-amount>
</ng-template>
<ng-template
  #titresParticipatifsProjectDuration
  [appCtrlTemplate]="'titresParticipatifsProjectDuration'"
>
  <titres-participatifs-project-duration>
  </titres-participatifs-project-duration>
</ng-template>
<ng-template
  #titresParticipatifsFees
  [appCtrlTemplate]="'titresParticipatifsFees'"
>
  <titres-participatifs-fees> </titres-participatifs-fees>
</ng-template>

<ng-template
  #diversificationInvestmentAmount
  [appCtrlTemplate]="'diversificationInvestmentAmount'"
>
  <diversification-investment-amount> </diversification-investment-amount>
</ng-template>
<ng-template
  #diversificationInvestmentProjectDuration
  [appCtrlTemplate]="'diversificationInvestmentProjectDuration'"
>
  <diversification-investment-project-duration>
  </diversification-investment-project-duration>
</ng-template>
<ng-template
  #diversificationInvestmentFees
  [appCtrlTemplate]="'diversificationInvestmentFees'"
>
  <diversification-investment-fees> </diversification-investment-fees>
</ng-template>

<ng-template #compteTitreAmount [appCtrlTemplate]="'compteTitreAmount'">
  <compte-titre-amount> </compte-titre-amount>
</ng-template>
<ng-template
  #compteTitreProjectDuration
  [appCtrlTemplate]="'compteTitreProjectDuration'"
>
  <compte-titre-project-duration> </compte-titre-project-duration>
</ng-template>
<ng-template #compteTitreFees [appCtrlTemplate]="'compteTitreFees'">
  <compte-titre-fees> </compte-titre-fees>
</ng-template>

<!--
// FPCI -->

<ng-template #fpciAmount [appCtrlTemplate]="'fpciAmount'">
  <fpci-amount> </fpci-amount>
</ng-template>
<ng-template #fpciProjectDuration [appCtrlTemplate]="'fpciProjectDuration'">
  <fpci-project-duration> </fpci-project-duration>
</ng-template>
<ng-template #fpciFees [appCtrlTemplate]="'fpciFees'">
  <fpci-fees> </fpci-fees>
</ng-template>

<!--
// fip -->
<ng-template #fipAmount [appCtrlTemplate]="'fipAmount'">
  <fip-amount> </fip-amount>
</ng-template>

<ng-template #fipProjectDuration [appCtrlTemplate]="'fipProjectDuration'">
  <fip-project-duration> </fip-project-duration>
</ng-template>

<ng-template #sendDocument [appCtrlTemplate]="'sendDocument'">
  <send-documents> </send-documents>
</ng-template>

<!-- fcpr -->
<ng-template #fcprAmount [appCtrlTemplate]="'fcprAmount'">
  <fcpr-amount> </fcpr-amount>
</ng-template>

<ng-template #fcprFees [appCtrlTemplate]="'fcprFees'">
  <fcpr-fees> </fcpr-fees>
</ng-template>

<!-- esg -->
<ng-template
  #esgInvestmentSituation
  [appCtrlTemplate]="'esgInvestmentSituation'"
>
  <esg-investment-situation> </esg-investment-situation>
</ng-template>

<ng-template #esgInvestmentList [appCtrlTemplate]="'esgInvestmentList'">
  <esg-investment-list> </esg-investment-list>
</ng-template>

<ng-template #esgSituation [appCtrlTemplate]="'esgSituation'">
  <esg-situation> </esg-situation>
</ng-template>

<ng-template #taxonomy [appCtrlTemplate]="'taxonomy'">
  <taxonomy> </taxonomy>
</ng-template>

<ng-template #scpiDivident [appCtrlTemplate]="'scpiDivident'">
  <scpi-divident> </scpi-divident>
</ng-template>
<ng-template #scpiPledgeOfShares [appCtrlTemplate]="'scpiPledgeOfShares'">
  <scpi-pledge-of-shares> </scpi-pledge-of-shares>
</ng-template>
<ng-template
  #scpiAlreadyClientOfProduct
  [appCtrlTemplate]="'scpiAlreadyClientOfProduct'"
>
  <scpi-already-client-of-product> </scpi-already-client-of-product>
</ng-template>
<ng-template
  #rcdaComparaisonProducts
  [appCtrlTemplate]="'rcdaComparaisonProducts'"
>
  <rcda-comparaison-products> </rcda-comparaison-products>
</ng-template>
<ng-template #rcdaDevisSelection [appCtrlTemplate]="'rcdaDevisSelection'">
  <rcda-devis-selection> </rcda-devis-selection>
</ng-template>
<ng-template #rcdaRecommandation [appCtrlTemplate]="'rcdaRecommandation'">
  <rcda-recommandation> </rcda-recommandation>
</ng-template>
<ng-template #scpiScheduledPayment [appCtrlTemplate]="'scpiScheduledPayment'">
  <scpi-scheduled-payment> </scpi-scheduled-payment>
</ng-template>
<ng-template #optionEpargneHandicap [appCtrlTemplate]="'optionEpargneHandicap'">
  <option-epargne-handicap> </option-epargne-handicap>
</ng-template>
<!-- per -->
<ng-template
  #perOptionConfiguration
  [appCtrlTemplate]="'perOptionConfiguration'"
>
  <per-option-configuration> </per-option-configuration>
</ng-template>
<ng-template #perSubscriberInfo [appCtrlTemplate]="'perSubscriberInfo'">
  <per-subscriber-info> </per-subscriber-info>
</ng-template>
<ng-template #perType [appCtrlTemplate]="'perType'">
  <per-type> </per-type>
</ng-template>
<ng-template
  #perDeductionConfiguration
  [appCtrlTemplate]="'perDeductionConfiguration'"
>
  <per-deduction-configuration> </per-deduction-configuration>
</ng-template>
<ng-template #perExitConfiguration [appCtrlTemplate]="'perExitConfiguration'">
  <per-exit-configuration> </per-exit-configuration>
</ng-template>

<!-- GFV -->

<ng-template
  #gfvAlreadyAssociateOfProduct
  [appCtrlTemplate]="'gfvAlreadyAssociateOfProduct'"
>
  <gfv-already-associate-of-product> </gfv-already-associate-of-product>
</ng-template>
<ng-template #gfvNbPartsComponent [appCtrlTemplate]="'gfvNbPartsComponent'">
  <gfv-nb-parts> </gfv-nb-parts>
</ng-template>

<!-- CONTIGENCY -->
<ng-template
  #swisslifePrevoyanceComponent
  [appCtrlTemplate]="'swisslifePrevoyanceComponent'"
>
  <swisslife-prevoyance> </swisslife-prevoyance>
</ng-template>
<ng-template
  #contigencyInformationsComponent
  [appCtrlTemplate]="'contigencyInformationsComponent'"
>
  <contigency-informations> </contigency-informations>
</ng-template>
<ng-template
  #contigencyProtectLovedComponent
  [appCtrlTemplate]="'contigencyProtectLovedComponent'"
>
  <contigency-protect-loved> </contigency-protect-loved>
</ng-template>
<ng-template
  #contigencyMaintainIncomeComponent
  [appCtrlTemplate]="'contigencyMaintainIncomeComponent'"
>
  <contigency-maintain-income> </contigency-maintain-income>
</ng-template>
<ng-template
  #contigencyGarantiesComponent
  [appCtrlTemplate]="'contigencyGarantiesComponent'"
>
  <contigency-garanties> </contigency-garanties>
</ng-template>
<ng-template
  #contigencyRegimeProfessionComponent
  [appCtrlTemplate]="'contigencyRegimeProfessionComponent'"
>
  <contigency-regime-profession> </contigency-regime-profession>
</ng-template>

<!-- INSURANCE (Mutuelle) -->
<ng-template
  #insuranceHypothesesComponent
  [appCtrlTemplate]="'insuranceHypothesesComponent'"
>
  <insurance-hypotheses> </insurance-hypotheses>
</ng-template>
<ng-template
  #insuranceInformationsComponent
  [appCtrlTemplate]="'insuranceInformationsComponent'"
>
  <insurance-informations> </insurance-informations>
</ng-template>
<ng-template
  #insuranceGarantiesComponent
  [appCtrlTemplate]="'insuranceGarantiesComponent'"
>
  <insurance-garanties> </insurance-garanties>
</ng-template>

<!-- GFI/GFF -->
<ng-template
  #gfiGffNbPartsComponent
  [appCtrlTemplate]="'gfiGffNbPartsComponent'"
>
  <gfi-gff-nb-parts> </gfi-gff-nb-parts>
</ng-template>

<!-- PrivateEquity -->
<ng-template #privateEquityAmount [appCtrlTemplate]="'privateEquityAmount'">
  <private-equity-amount> </private-equity-amount>
</ng-template>
<ng-template
  #privateEquityProjectDuration
  [appCtrlTemplate]="'privateEquityProjectDuration'"
>
  <private-equity-project-duration> </private-equity-project-duration>
</ng-template>

<ng-template #privateEquityFees [appCtrlTemplate]="'privateEquityFees'">
  <private-equity-fees> </private-equity-fees>
</ng-template>

<ng-template
  #privateEquityProjectType
  [appCtrlTemplate]="'privateEquityProjectType'"
>
  <private-equity-project-type> </private-equity-project-type>
</ng-template>

<ng-template #maximumLostPercent [appCtrlTemplate]="'maximumLostPercent'">
  <maximum-lost-percent> </maximum-lost-percent>
</ng-template>

<ng-template #ownerTaxResidence [appCtrlTemplate]="'ownerTaxResidence'">
  <owner-tax-residence> </owner-tax-residence>
</ng-template>

<!-- additional-question -->
<ng-template #financialMarket [appCtrlTemplate]="'financialMarket'">
  <financial-market> </financial-market>
</ng-template>
<ng-template
  #additionalQuestionInvestment
  [appCtrlTemplate]="'additionalQuestionInvestment'"
>
  <additional-question-investment> </additional-question-investment>
</ng-template>
<ng-template #realEstateMarkets [appCtrlTemplate]="'realEstateMarkets'">
  <real-estate-markets> </real-estate-markets>
</ng-template>
<!-- /additional-question -->

<!-- cat -->
<ng-template #catAmount [appCtrlTemplate]="'catAmount'">
  <cat-amount> </cat-amount>
</ng-template>

<!-- immobilier -->
<ng-template
  #realEstateCharacteristics
  [appCtrlTemplate]="'realEstateCharacteristics'"
>
  <real-estate-characteristics> </real-estate-characteristics>
</ng-template>
<ng-template
  #realEstateCharacteristics2
  [appCtrlTemplate]="'realEstateCharacteristics2'"
>
  <real-estate-characteristics2> </real-estate-characteristics2>
</ng-template>
<ng-template
  #realEstateCharacteristicsCristalis
  [appCtrlTemplate]="'realEstateCharacteristicsCristalis'"
>
  <real-estate-characteristics-cristalis>
  </real-estate-characteristics-cristalis>
</ng-template>
<ng-template #realEstateCosts [appCtrlTemplate]="'realEstateCosts'">
  <real-estate-costs> </real-estate-costs>
</ng-template>
<ng-template
  #realEstateOwnerShipType
  [appCtrlTemplate]="'realEstateOwnerShipType'"
>
  <real-estate-owner-ship-type> </real-estate-owner-ship-type>
</ng-template>
<ng-template #realEstateFiscalLaw [appCtrlTemplate]="'realEstateFiscalLaw'">
  <real-estate-fiscal-law> </real-estate-fiscal-law>
</ng-template>
<ng-template
  #realEstateInvestmentAmount
  [appCtrlTemplate]="'realEstateInvestmentAmount'"
>
  <real-estate-investment-amount> </real-estate-investment-amount>
</ng-template>
<ng-template
  #realEstatePinelParameters
  [appCtrlTemplate]="'realEstatePinelParameters'"
>
  <real-estate-pinel-parameters> </real-estate-pinel-parameters>
</ng-template>
<ng-template
  #realEstateLmplmnpParameters
  [appCtrlTemplate]="'realEstateLmplmnpParameters'"
>
  <real-estate-lmplmnpparameters> </real-estate-lmplmnpparameters>
</ng-template>

<ng-template
  #realEstateRiskAversion
  [appCtrlTemplate]="'realEstateRiskAversion'"
>
  <real-estate-risk-aversion> </real-estate-risk-aversion>
</ng-template>

<!--/ immobilier -->

<!-- Profil emprunteur -->

<ng-template #smokerForm [appCtrlTemplate]="'smokerForm'">
  <smoker-form> </smoker-form>
</ng-template>
<ng-template
  #deplacementTravailHauteurForm
  [appCtrlTemplate]="'deplacementTravailHauteurForm'"
>
  <deplacement-travail-hauteur-form> </deplacement-travail-hauteur-form>
</ng-template>
<ng-template #travailManuelForm [appCtrlTemplate]="'travailManuelForm'">
  <travail-manuel-form> </travail-manuel-form>
</ng-template>
<ng-template #travailRisqueForm [appCtrlTemplate]="'travailRisqueForm'">
  <travail-risque-form> </travail-risque-form>
</ng-template>
<ng-template #sportDeplacementsForm [appCtrlTemplate]="'sportDeplacementsForm'">
  <sport-deplacements-form> </sport-deplacements-form>
</ng-template>
<ng-template #optionsEmprunteurForm [appCtrlTemplate]="'optionsEmprunteurForm'">
  <options-emprunteur-form> </options-emprunteur-form>
</ng-template>

<!-- SCPI Perial -->
<ng-template #scpiFinanceExperience [appCtrlTemplate]="'scpiFinanceExperience'">
  <scpi-finance-experience> </scpi-finance-experience>
</ng-template>
<ng-template
  #scpiFinancialInstruments
  [appCtrlTemplate]="'scpiFinancialInstruments'"
>
  <scpi-financial-instruments> </scpi-financial-instruments>
</ng-template>
<ng-template #scpiStockTransactions [appCtrlTemplate]="'scpiStockTransactions'">
  <scpi-stock-transactions-last-year> </scpi-stock-transactions-last-year>
</ng-template>

<ng-template
  #scpiObligationsTransactions
  [appCtrlTemplate]="'scpiObligationsTransactions'"
>
  <scpi-obligations-transactions-last-year>
  </scpi-obligations-transactions-last-year>
</ng-template>
<ng-template
  #scpiMonetairesTransactions
  [appCtrlTemplate]="'scpiMonetairesTransactions'"
>
  <scpi-monetaires-transactions-last-year>
  </scpi-monetaires-transactions-last-year>
</ng-template>

<ng-template
  #scpiStructuredProductsTransactions
  [appCtrlTemplate]="'scpiStructuredProductsTransactions'"
>
  <scpi-structured-products-transactions-last-year>
  </scpi-structured-products-transactions-last-year>
</ng-template>
<ng-template
  #scpiIndirectRealEstateTransactions
  [appCtrlTemplate]="'scpiIndirectRealEstateTransactions'"
>
  <scpi-indirect-real-estate-transactions-last-year>
  </scpi-indirect-real-estate-transactions-last-year>
</ng-template>
<ng-template #scpiOtherTransactions [appCtrlTemplate]="'scpiOtherTransactions'">
  <scpi-other-transactions-last-year> </scpi-other-transactions-last-year>
</ng-template>

<ng-template
  #scpiAverageAmountTransactions
  [appCtrlTemplate]="'scpiAverageAmountTransactions'"
>
  <scpi-average-amount-transactions> </scpi-average-amount-transactions>
</ng-template>
<ng-template
  #scpiAverageNumberTransactions
  [appCtrlTemplate]="'scpiAverageNumberTransactions'"
>
  <scpi-average-number-transactions> </scpi-average-number-transactions>
</ng-template>
<!-- /SCPI Perial -->

<!-- CRISTALIS -->
<ng-template #enrollmentOffice [appCtrlTemplate]="'enrollmentOffice'">
  <enrollment-office> </enrollment-office>
</ng-template>
<ng-template #jointOwnershipChoice [appCtrlTemplate]="'jointOwnershipChoice'">
  <joint-ownership-choice> </joint-ownership-choice>
</ng-template>
<ng-template #jointOwnership [appCtrlTemplate]="'jointOwnership'">
  <joint-ownership> </joint-ownership>
</ng-template>
<ng-template #missionParticulier [appCtrlTemplate]="'missionParticulier'">
  <mission-particulier> </mission-particulier>
</ng-template>
<ng-template #missionLegalEntity [appCtrlTemplate]="'missionLegalEntity'">
  <mission-legal-entity> </mission-legal-entity>
</ng-template>
<ng-template #optionParticulier [appCtrlTemplate]="'optionParticulier'">
  <option-particulier> </option-particulier>
</ng-template>

<ng-template #startDateRent [appCtrlTemplate]="'startDateRent'">
  <start-date-rent> </start-date-rent>
</ng-template>
<ng-template #startDateMission [appCtrlTemplate]="'startDateMission'">
  <start-date-mission> </start-date-mission>
</ng-template>
<ng-template #finalDateMission [appCtrlTemplate]="'finalDateMission'">
  <final-date-mission> </final-date-mission>
</ng-template>
<ng-template
  #finalDateMissionCustom
  [appCtrlTemplate]="'finalDateMissionCustom'"
>
  <final-date-mission-custom> </final-date-mission-custom>
</ng-template>

<ng-template #cgaSituation [appCtrlTemplate]="'cgaSituation'">
  <cga-situation> </cga-situation>
</ng-template>
<ng-template #tradeDiscount [appCtrlTemplate]="'tradeDiscount'">
  <trade-discount> </trade-discount>
</ng-template>
<ng-template #optionLegalEntity [appCtrlTemplate]="'optionLegalEntity'">
  <option-legal-entity> </option-legal-entity>
</ng-template>
<ng-template #paymentFrequency [appCtrlTemplate]="'paymentFrequency'">
  <payment-frequency> </payment-frequency>
</ng-template>
<!-- /CRISTALIS -->

<ng-template
  #leadCompletionSubscription
  [appCtrlTemplate]="'leadCompletionSubscription'"
>
  <lead-completion-subscription> </lead-completion-subscription>
</ng-template>
<ng-template
  #sendCompletionSubscriptionEmail
  [appCtrlTemplate]="'sendCompletionSubscriptionEmail'"
>
  <send-completion-subscription-email> </send-completion-subscription-email>
</ng-template>
<ng-template #documentCompliance [appCtrlTemplate]="'documentCompliance'">
  <document-compliance> </document-compliance>
</ng-template>

<ng-template #finalPage [appCtrlTemplate]="'finalPage'">
  <ea-subscription-final-page></ea-subscription-final-page>
</ng-template>

<ng-template #arbitrageType [appCtrlTemplate]="'arbitrageType'">
  <arbitrage-type-form></arbitrage-type-form>
</ng-template>
<ng-template #arbitrageReason [appCtrlTemplate]="'arbitrageReason'">
  <arbitrage-reason-form></arbitrage-reason-form>
</ng-template>
<ng-template #contractInformations [appCtrlTemplate]="'contractInformations'">
  <contract-informations-form></contract-informations-form>
</ng-template>
<ng-template
  #arbitrageDisinvestmentForm
  [appCtrlTemplate]="'arbitrageDisinvestmentForm'"
>
  <arbitrage-disinvestment-form></arbitrage-disinvestment-form>
</ng-template>
<ng-template
  #arbitrageInvestmentAllocation
  [appCtrlTemplate]="'arbitrageInvestmentAllocation'"
>
  <arbitrage-investment-allocation-form></arbitrage-investment-allocation-form>
</ng-template>
<ng-template
  #arbitrageSimulationPacks
  [appCtrlTemplate]="'arbitrageSimulationPacks'"
>
  <arbitrage-simulation-packs></arbitrage-simulation-packs>
</ng-template>
<ng-template #reinvestmentStockForm [appCtrlTemplate]="'reinvestmentStockForm'">
  <reinvestment-stock-form></reinvestment-stock-form>
</ng-template>
<ng-template #reinvestmentFluxForm [appCtrlTemplate]="'reinvestmentFluxForm'">
  <reinvestment-flux-form></reinvestment-flux-form>
</ng-template>
<ng-template #versementAmountForm [appCtrlTemplate]="'versementAmountForm'">
  <versement-amount-form></versement-amount-form>
</ng-template>
<ng-template
  #tauxParSupportArbitrage
  [appCtrlTemplate]="'tauxParSupportArbitrage'"
>
  <taux-par-support-arbitrage></taux-par-support-arbitrage>
</ng-template>
<ng-template
  #versementsLibresFeesForm
  [appCtrlTemplate]="'versementsLibresFeesForm'"
>
  <versements-libres-fees-form></versements-libres-fees-form>
</ng-template>
<ng-template #fiscalityTypeForm [appCtrlTemplate]="'fiscalityTypeForm'">
  <fiscality-type-form></fiscality-type-form>
</ng-template>
<ng-template
  #versementInvestmentAllocation
  [appCtrlTemplate]="'versementInvestmentAllocation'"
>
  <versement-investment-allocation-form></versement-investment-allocation-form>
</ng-template>
<ng-template
  #versementSimulationPacks
  [appCtrlTemplate]="'versementSimulationPacks'"
>
  <versement-simulation-packs></versement-simulation-packs>
</ng-template>
<ng-template
  #versementsLibresSupportsForm
  [appCtrlTemplate]="'versementsLibresSupportsForm'"
>
  <versement-libres-supports-form></versement-libres-supports-form>
</ng-template>
<ng-template
  #tauxParSupportVersement
  [appCtrlTemplate]="'tauxParSupportVersement'"
>
  <taux-par-support-versement></taux-par-support-versement>
</ng-template>
<ng-template
  #operationCurrentAllocationForm
  [appCtrlTemplate]="'operationCurrentAllocationForm'"
>
  <operation-current-allocation-form></operation-current-allocation-form>
</ng-template>
<ng-template #transferForm [appCtrlTemplate]="'transferForm'">
  <transfer-form></transfer-form> </ng-template
><ng-template #transferSupportsForm [appCtrlTemplate]="'transferSupportsForm'">
  <transfer-supports-form></transfer-supports-form>
</ng-template>
<ng-template
  #tauxParSupportTransfer
  [appCtrlTemplate]="'tauxParSupportTransfer'"
>
  <taux-par-support-transfer></taux-par-support-transfer>
</ng-template>
<ng-template
  #ordreDeRemplacementForm
  [appCtrlTemplate]="'ordreDeRemplacementForm'"
>
  <transfer-supports-form></transfer-supports-form>
</ng-template>
<ng-template #rachatForm [appCtrlTemplate]="'rachatForm'">
  <rachat-form></rachat-form>
</ng-template>
<ng-template #rachatAmountForm [appCtrlTemplate]="'rachatAmountForm'">
  <rachat-amount-form></rachat-amount-form>
</ng-template>
<ng-template
  #rachatDisinvestmentForm
  [appCtrlTemplate]="'rachatDisinvestmentForm'"
>
  <rachat-disinvestment-form></rachat-disinvestment-form>
</ng-template>
<ng-template #rachatPartielTypeForm [appCtrlTemplate]="'rachatPartielTypeForm'">
  <rachat-partiel-type-form></rachat-partiel-type-form>
</ng-template>
<ng-template
  #rachatProgrammedAmountForm
  [appCtrlTemplate]="'rachatProgrammedAmountForm'"
>
  <rachat-programmed-amount-form></rachat-programmed-amount-form>
</ng-template>
<ng-template
  #rachatProgrammedDisinvestmentForm
  [appCtrlTemplate]="'rachatProgrammedDisinvestmentForm'"
>
  <rachat-programmed-disinvestment-form></rachat-programmed-disinvestment-form>
</ng-template>
<ng-template #corumProfilesForm [appCtrlTemplate]="'corumProfilesForm'">
  <corum-profiles-form></corum-profiles-form>
</ng-template>
<ng-template #corumGestionLibreForm [appCtrlTemplate]="'corumGestionLibreForm'">
  <corum-gestion-libre-form></corum-gestion-libre-form>
</ng-template>
<ng-template #corumVersementForm [appCtrlTemplate]="'corumVersementForm'">
  <corum-versement-form></corum-versement-form>
</ng-template>
<ng-template
  #riskProfilFirstPartForm
  [appCtrlTemplate]="'riskProfilFirstPartForm'"
>
  <risk-profil-first-part-form></risk-profil-first-part-form>
</ng-template>
<ng-template
  #riskProfilSecondPartForm
  [appCtrlTemplate]="'riskProfilSecondPartForm'"
>
  <risk-profil-second-part-form> </risk-profil-second-part-form>
</ng-template>
<ng-template
  #riskProfilThirdPartForm
  [appCtrlTemplate]="'riskProfilThirdPartForm'"
>
  <risk-profil-third-part-form> </risk-profil-third-part-form>
</ng-template>
<ng-template
  #riskProfilFourthPartForm
  [appCtrlTemplate]="'riskProfilFourthPartForm'"
>
  <risk-profil-fourth-part-form> </risk-profil-fourth-part-form>
</ng-template>
<ng-template
  #riskProfilFifthPartForm
  [appCtrlTemplate]="'riskProfilFifthPartForm'"
>
  <risk-profil-fifth-part-form> </risk-profil-fifth-part-form>
</ng-template>
<ng-template
  #swisslifeGestionFinanciere
  [appCtrlTemplate]="'swisslifeGestionFinanciere'"
>
  <swisslife-gestion-financiere> </swisslife-gestion-financiere>
</ng-template>
<ng-template #discountForm [appCtrlTemplate]="'discountForm'">
  <discount-form> </discount-form>
</ng-template>
<ng-template
  #riskProfilCompanyFirstPartForm
  [appCtrlTemplate]="'riskProfilCompanyFirstPartForm'"
>
  <risk-profil-company-first-part-form> </risk-profil-company-first-part-form>
</ng-template>
<ng-template
  #riskProfilCompanySecondPartForm
  [appCtrlTemplate]="'riskProfilCompanySecondPartForm'"
>
  <risk-profil-company-second-part-form> </risk-profil-company-second-part-form>
</ng-template>
<ng-template
  #riskProfilCompanyFourthPartForm
  [appCtrlTemplate]="'riskProfilCompanyFourthPartForm'"
>
  <risk-profil-company-fourth-part-form> </risk-profil-company-fourth-part-form>
</ng-template>
<ng-template #investmentHorizon [appCtrlTemplate]="'investmentHorizon'">
  <investment-horizon> </investment-horizon>
</ng-template>
<ng-template #documentVerification [appCtrlTemplate]="'documentVerification'">
  <document-verification> </document-verification>
</ng-template>
<ng-template #perEffectiveDate [appCtrlTemplate]="'perEffectiveDate'">
  <per-effective-date> </per-effective-date>
</ng-template>
<ng-template
  #operationProgrammedPaymentsFrequencyForm
  [appCtrlTemplate]="'operationProgrammedPaymentsFrequencyForm'"
>
  <operation-programmed-payments-frequency-form>
  </operation-programmed-payments-frequency-form>
</ng-template>
<ng-template #peePercoFees [appCtrlTemplate]="'peePercoFees'">
  <pee-perco-fees-form> </pee-perco-fees-form>
</ng-template>
<ng-template #obligationsAmount [appCtrlTemplate]="'obligationsAmount'">
  <obligations-amount> </obligations-amount> </ng-template
><ng-template #obligationsFees [appCtrlTemplate]="'obligationsFees'">
  <obligations-fees> </obligations-fees>
</ng-template>
